import { convertDateForMappingQuestion, convertTimeForMappingQuestion } from '../../../utils/dateUtil';
import { mapClaimingFor } from './sharedMapper';
import {
  stepPersonalItemsExpenseLookup as expenseLookup,
  emptyClaimCode,
} from './claimCodeMapper';
import { mapToDelayedLuggageExpense } from './expenseMapper';

function mapToParentSection() {
  return {
    reserveAmount: 0,
    excess: 0,
    approvedAmount: 0,
    comments: null,
    fraudIndicator: null,
    urgentIndicator: null,
    recoveries: 0,
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question:
        'section6.claimForDamagedLostOrStolenLuggageTravelDocumentOrCash',
      answer: data.claimForDamagedLostOrStolenLuggageTravelDocumentOrCash,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.claimForDelayLuggage',
      answer: data.claimForDelayLuggage,
      claimTypeCode: claimCode,
    },
    // {
    //   question: 'section6.claimForPassportCreditCard',
    //   answer: data.claimForPassportCreditCard,
    //   claimTypeCode: claimCode,
    // },
    // {
    //   question: 'section6.claimForTheftOfCash',
    //   answer: data.claimForTheftOfCash,
    //   claimTypeCode: claimCode,
    // },
    {
      question: 'section6.claimForLuggageAndPersonalEffect',
      answer: data.claimForLuggageAndPersonalEffect,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.whereYouWereInRelationToTheItem',
      answer: data.whereYouWereInRelationToTheItem,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.howItHappened',
      answer: data.howItHappened,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.additional',
      answer: data.additional,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.city',
      answer: data.city,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.whoDidYouReportThisTo',
      answer: data.whoDidYouReportThisTo,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.otherDescription',
      answer: data.otherDescription,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.reportReferenceNumber',
      answer: data.reportReferenceNumber,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.nameOfTransportProvider',
      answer: data.nameOfTransportProvider,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.dateLuggageDelay',
      answer: convertDateForMappingQuestion(data.dateLuggageDelay),
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.timeLuggageDelay',
      answer: convertTimeForMappingQuestion(data.timeLuggageDelay),
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.dateLuggageReturn',
      answer: convertDateForMappingQuestion(data.dateLuggageReturn),
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.timeLuggageReturn',
      answer: convertTimeForMappingQuestion(data.timeLuggageReturn),
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.paidForDelay',
      answer: data.paidForDelay,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.madeClaimWithTravelProviderOrOther',
      answer: data.madeClaimWithTravelProviderOrOther,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.listedOnThePolicy',
      answer: data.listedOnThePolicy,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.claimingFor',
      answer: mapClaimingFor(data.claimingFor),
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.dateOfExpense',
      answer: data.dateCompensationWasReceived,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.description',
      answer: data.compensationDescription,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.currency',
      answer: data.amountOfCompensationCurrency,
      claimTypeCode: claimCode,
    },
    {
      question: 'section6.clientClaim',
      answer: data.amountOfCompensation,
      claimTypeCode: claimCode,
    },
  ];
}

function getAdditionalExpenseClaimCode(data) {
  switch ('true') {
    case data.claimForDamagedLostOrStolenLuggageTravelDocumentOrCash:
      return expenseLookup.claimForLuggageAndPersonalEffect;
    default:
      return emptyClaimCode;
  }
}

function getDelayedLuggageExpenseClaimCode(data) {
  switch ('true') {
    case data.claimForDelayLuggage:
      return expenseLookup.claimForDelayLuggage;
    default:
      return emptyClaimCode;
  }
}

function getAdditionalExpense(data) {
  const additionalExpenseClaimCode = getAdditionalExpenseClaimCode(data);

  return emptyClaimCode === additionalExpenseClaimCode
    ? []
    : data.additionalItems.map(
        mapToDelayedLuggageExpense,
        additionalExpenseClaimCode
      );
}

function getDelayedLuggageExpense(data) {
  const delayedLuggageExpenseClaimCode = getDelayedLuggageExpenseClaimCode(
    data
  );

  return emptyClaimCode === delayedLuggageExpenseClaimCode
    ? []
    : data.delayedLuggageExpenses.map(
        mapToDelayedLuggageExpense,
        delayedLuggageExpenseClaimCode
      );
}

function mapToExpenses(data) {
  const additionalItems = getAdditionalExpense(data);
  const delayedLuggageExpenses = getDelayedLuggageExpense(data);
  const expenses = [...additionalItems, ...delayedLuggageExpenses];
  return expenses;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPersonalItemsDataMapper.js